/**
 * roleLabels — canonical role code to human display label.
 *
 * The platform role model is seven admin-side codes plus CLIENT:
 *   AD / UDP / CCO / DR / BDC / CONSULTANT / EMPLOYEE
 *
 * AD is surfaced to admins as "Platform Manager" everywhere in the UI — the
 * bare "AD" code is an internal identifier and must never render to a user.
 * DR is live again (Dealing Representative), and UDP / CCO complete the
 * compliance hierarchy UDP > CCO > DR. A user may hold several of these at
 * once, so callers that render a session's roles map each code through
 * roleLabel and join the results.
 *
 * roleLabel(code) is intentionally forgiving: any unknown / null code falls
 * back to the raw string so a new backend code never renders as blank.
 */
export const ROLE_LABELS = {
  AD: "Platform Manager",
  UDP: "Ultimate Designated Person",
  CCO: "Chief Compliance Officer",
  DR: "Dealing Representative",
  BDC: "Business Development Contractor",
  CONSULTANT: "Consultant",
  EMPLOYEE: "Employee",
  CLIENT: "Client",
};

/**
 * roleLabel — map a canonical role code to its display label.
 * Unknown / falsy codes return the raw code (or an empty string for null),
 * so callers can render the result directly without a guard.
 */
export function roleLabel(code) {
  if (code == null) return "";
  return ROLE_LABELS[code] || String(code);
}

export default roleLabel;
